import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunk';
import { initialState, SLICE_NAMESPACE } from './constants';
import { reducers } from './reducers';

const { actions, reducer } = createSlice({
  name: SLICE_NAMESPACE,
  initialState,
  reducers,
  extraReducers,
});

export const { clearModuleNavigationState } = actions;
export default reducer;
